import React, { useEffect, useRef, useState } from 'react'

import { Steps, Panel, Icon } from 'rsuite'
import style from './style.css'
import { useSelector } from 'react-redux'

export default function ProjectProgressStep({ schema, hidShaded = true }) {
  const { isExpanded } = useSelector((state) => state.schemaSidebar)
  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth, isExpanded])

  return (
    <div ref={containerRef}>
      <Panel shaded={hidShaded} bordered collapsible defaultExpanded>
        <div>
          <Steps
            current={schema.current}
            currentStatus={schema.currentStatus}
            vertical={containerWidth < 450}
          >
            {schema.item?.map((item, index) => (
              <Steps.Item
                key={index}
                title={item}
                description={
                  index == schema.current && (
                    <p style={descriptionStyle}>{schema.currentStatusInfo}</p>
                  )
                }
                icon={index < schema.current && <Icon icon="check-circle" size="2x" />}
              />
            ))}
          </Steps>
        </div>
      </Panel>
    </div>
  )
}

const descriptionStyle = {
  color: '#ff9800',
  fontSize: '0.9em',
}
